// The original "build a survey" view: config + matrix + appointment list + share.
// This is what the user sees on `/`.

import { Store } from '../store';
import { renderAppHeader } from './app-header';
import { renderConfigPanel } from './config-panel';
import { renderMatrix, setBusyEvents } from './matrix';
import { renderAppointmentList } from './appointment-list';
import { renderSharePanel } from './share-panel';
import { renderCalendarPanel } from './calendar-panel';

export function renderBuilderView(root: HTMLElement): void {
  const store = new Store();
  root.append(
    renderAppHeader(),
    renderConfigPanel(store),
    renderCalendarPanel({ onUpdate: setBusyEvents }),
    renderMatrix(store),
    renderAppointmentList(store),
    renderSharePanel(store),
  );
}
